import { tooltips } from './contentStatusTooltips';
import {
  useVisualContentSyncStatus,
  type VisualSyncStatus
} from './useVisualContentSyncStatus';

export type snackbarMessage =
  | 'online'
  | 'offline'
  | 'sessionLocked'
  | 'readOnlyModeActive'
  | 'viewToEditAccess'
  | 'editToViewAccess'
  | 'editToViewOfflineChangesDiscarded';

export const useContentStatusHeader = (
  contentId: string,
  snackbarMessages: Record<snackbarMessage, string>
): {
  status: VisualSyncStatus;
  tooltip?: string;
} => {
  const status = useVisualContentSyncStatus(contentId, snackbarMessages);

  return {
    status,
    tooltip: ['saved', 'saving', 'offline'].includes(status)
      ? tooltips[status]
      : undefined
  };
};
